import { useEffect, useState } from "react";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { useSelector, useDispatch } from "react-redux";
import { useRouter } from "next/router";
import Link from "next/link";
import Head from "next/head";
import { API_BASE_URL } from "../../../libs/generalSettings";
import { get, postJSON } from "../../../libs/services/request";
import { MetinKisalt, SeoUrlRegex } from "../../../libs/utils";
import { encryptJson, decrypt } from "../../../libs/encryption";
import { incrementCartItemCount } from "../../../redux/stores/basket";
import Language from "../../../locales/GetLanguageResourceResponse.json";
import Loader from "../../../components/Loader";
import Image from "next/image";

const UrunDetay = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Modal açma ve kapama
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  const [loaderIsShow, setLoaderIsShow] = useState(false);
  const [getUrunler, setUrunler] = useState([]);
  const [adetSayisi, setAdet] = useState(1);
  const [language, setLanguage] = useState("tr");
  const languageStore = useSelector((state) => state.language);
  const isLoggin = decrypt(useSelector((state) => state.auth.loggedIn));
  const userId = decrypt(useSelector((state) => state.auth.user));
  const token = decrypt(useSelector((state) => state.auth.authorization));
  const cleanedToken = token.replace(/"/g, "");
  const router = useRouter();
  const dispatch = useDispatch();

  const { id } = router.query;
  useEffect(() => {
    (async () => {
      await get(
        `${API_BASE_URL}/getUrunlerByUrunId?urunId=${id}&dil=${languageStore}`
      ).then((result) => {
        {
          if (result.sonuc === true) {
            setLanguage(languageStore);
            setUrunler(result.data);
            //burda kaldık
            if (result.data.stokAdet < 1) {
              var getBtnSepeteEkle = document.getElementsByName(`sepete-ekle`);
              getBtnSepeteEkle.forEach((btn) => {
                btn.disabled = true;
              });
              var getBtnSatinAl = document.getElementsByName(`satin-al`);
              getBtnSatinAl.forEach((btn) => {
                btn.style.display = "none";
              });
            }

            setLoaderIsShow(true);
          } else {
          }
        }
      });
    })();
  }, [id, languageStore]);
  // useEffect(() => {
  //   var zoomContainer = document.querySelector(".zoom-container");
  //   var zoomImage = zoomContainer.querySelector("img");
  //   var zoomOverlay = document.createElement("div");
  //   zoomOverlay.classList.add("zoom-overlay");
  //   zoomContainer.appendChild(zoomOverlay);

  //   var zoomCursor = zoomContainer.querySelector(".zoom-cursor");

  //   var scale = 1;
  //   var minScale = 1;
  //   var maxScale = 2;
  //   var scaleStep = 0.1;
  //   var isPanning = false;
  //   var startX, startY, translateX, translateY;

  //   zoomContainer.addEventListener("wheel", zoomImageOnWheel);
  //   zoomContainer.addEventListener("mousemove", updateZoomCursor);
  //   zoomContainer.addEventListener("mousedown", startPanning);
  //   zoomContainer.addEventListener("mouseup", stopPanning);
  //   zoomContainer.addEventListener("mouseleave", stopPanning);
  //   zoomContainer.addEventListener("mousemove", panImage);

  //   function zoomImageOnWheel(event) {
  //     event.preventDefault();

  //     var delta = event.deltaY || event.detail || -event.wheelDelta;

  //     if (delta > 0 && scale > minScale) {
  //       scale -= scaleStep;
  //     } else if (delta < 0 && scale < maxScale) {
  //       scale += scaleStep;
  //     }

  //     zoomImage.style.transform = "scale(" + scale + ")";
  //   }

  //   function updateZoomCursor(event) {
  //     var containerRect = zoomContainer.getBoundingClientRect();
  //     var mouseX = event.clientX - containerRect.left;
  //     var mouseY = event.clientY - containerRect.top;

  //     zoomCursor.style.left = mouseX + "px";
  //     zoomCursor.style.top = mouseY + "px";
  //   }

  //   function startPanning(event) {
  //     event.preventDefault();
  //     isPanning = true;
  //     startX = event.clientX;
  //     startY = event.clientY;
  //     translateX = 0;
  //     translateY = 0;
  //     zoomImage.style.cursor = "grabbing";
  //   }

  //   function stopPanning() {
  //     isPanning = false;
  //     zoomImage.style.cursor = "grab";
  //   }

  //   function panImage(event) {
  //     if (!isPanning) return;
  //     event.preventDefault();
  //     var deltaX = event.clientX - startX;
  //     var deltaY = event.clientY - startY;
  //     translateX += deltaX;
  //     translateY += deltaY;
  //     startX = event.clientX;
  //     startY = event.clientY;
  //     zoomImage.style.transform =
  //       "translate(" +
  //       translateX +
  //       "px, " +
  //       translateY +
  //       "px) scale(" +
  //       scale +
  //       ")";
  //   }
  // });

  const SepeteEkle = async (product) => {
    if (isLoggin) {
      var uid = JSON.parse(userId);
      const params = {
        urunId: product.urunId,
        musteriId: uid.fltMusteriId,
        adet: adetSayisi,
        token: cleanedToken,
      };
      await postJSON(`${API_BASE_URL}/sepeteUrunEkle`, params).then(
        (result) => {
          {
            if (result.sonuc === true) {
              let timerInterval;
              Swal.fire({
                title: Language[languageStore].urunSepeteEklendi,
                html: "<b>" + product.urunAd + "</b>",
                icon: "success",
                timer: 3000,
                timerProgressBar: true,
                didOpen: () => {
                  Swal.showLoading();
                },
              });
              dispatch(incrementCartItemCount());
            } else {
              Swal.fire({
                title: Language[languageStore].urunSepeteEklenmedi,
                html: "<b>" + product.urunAd + "</b>",
                icon: "error",
                timer: 3000,
                timerProgressBar: true,
                didOpen: () => {
                  Swal.showLoading();
                },
              });
            }
          }
        }
      );
    } else {
      router.push("/login");
    }
  };
  const AdetArttir = (param) => {
    var getBtn = document.getElementsByName(`btn-dusur-${param.urunId}`);
    getBtn.forEach((btn) => {
      btn.disabled = false;
    });
    var getInput = document.getElementById(param.urunId);
    if (getInput.value >= param.stokAdet) {
      var getBtn = document.getElementsByName(`btn-arttir-${param.urunId}`);
      getBtn.forEach((btn) => {
        btn.disabled = false;
      });
    } else {
      let adetim = adetSayisi + 1;
      setAdet(adetim);
      let adet = parseInt(getInput.value);
      // adet = adet + 1;
      getInput.value = adetSayisi;
    }
  };

  const AdetDusur = (param) => {
    var getInput = document.getElementById(param.urunId);
    if (getInput.value === "1") {
      var getBtn = document.getElementsByName(`btn-dusur-${param.urunId}`);
      getBtn.forEach((btn) => {
        btn.disabled = true;
      });
      setAdet(1);
    } else {
      var getInput = document.getElementById(param.urunId);
      let adetim = adetSayisi - 1;
      setAdet(adetim);
      let adet = parseInt(getInput.value);
      // adet = adet - 1;
      getInput.value = adetSayisi;
    }
  };
  const handleChangeAdet = (event) => {
    setAdet(event.target.value);
  };
  return (
    <>
      <Head>
        <title>
          {Language[languageStore].webTitle} | {getUrunler.urunAd}
        </title>
      </Head>
      {!loaderIsShow ? <Loader /> : ""}
      <section className="section-box shop-template">
        <div className="container">
          <div className="row mt-50 mb-30">
            <div className="col-lg-5">
              <div className="gallery-image">
                <div className="galleries">
                  <div
                    className="zoom-container"
                    onClick={openModal}
                    title="Resimi Büyült">
                    <img
                      src={getUrunler.resimLink}
                      title={getUrunler.urunAd}
                      width={500}
                      height={350}
                      style={{ objectFit: "fill", cursor: "pointer" }}
                      onClick={openModal}
                      alt={getUrunler.urunAd}
                    />
                    <div className="zoom-cursor"></div>
                  </div>

                  {/* Modal */}
                  {isModalOpen && (
                    <div
                      style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(0, 0, 0, 0.8)", // Karartma efekti
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 1000,
                      }}
                      onClick={closeModal} // Modal dışına tıklayınca kapat
                    >
                      {/* Modal İçeriği */}
                      <div
                        style={{
                          position: "relative",
                          background: "white",
                          width: "100%",
                          maxWidth: "700px",
                          padding: "20px",
                          borderRadius: "8px",
                          boxShadow: "0 5px 15px rgba(0, 0, 0, 0.5)",
                          textAlign: "center",
                        }}>
                        <img
                          src={getUrunler.resimLink}
                          title={getUrunler.urunAd}
                          style={{
                            maxWidth: "100%",
                            maxHeight: "100%",
                            border: "2px solid white",
                            boxShadow: "0 0 10px rgba(255, 255, 255, 0.5)",
                          }}
                        />
                        {/* Kapat Butonu */}
                        <button
                          onClick={closeModal}
                          style={{
                            position: "absolute",
                            top: 10,
                            right: 10,
                            background: "transparent",
                            border: "none",
                            color: "black",
                            fontSize: "24px",
                            cursor: "pointer",
                          }}>
                          &times;
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="col-lg-7">
              <div className="row">
                <div className="col-lg-12 col-md-7 mb-30">
                  <h3 className="color-brand-3 mb-25">{getUrunler.urunAd}</h3>
                  <ul className="list-dot">
                    <li>
                      {Language[languageStore].urunKoduTitle} :{" "}
                      {getUrunler.urunKod}
                    </li>
                    <li>
                      {Language[languageStore].stokKod} :{getUrunler.stokKod}
                    </li>
                    <li>
                      {" "}
                      {Language[languageStore].stokAdetiTitle}: (
                      <b>{getUrunler.stokAdet}</b>)
                    </li>

                    <li>
                      {Language[languageStore].baskiYontemiTitle}:
                      {getUrunler.baskiYontemi}
                    </li>
                    <li>
                      {Language[languageStore].pulBoyutu} :{getUrunler.pulBoyut}
                    </li>
                    <li>
                      {Language[languageStore].tabakadakiAdet} :
                      {getUrunler.tabakadakiAdet}
                    </li>
                    <li>
                      {Language[languageStore].traj} :{getUrunler.traj}
                    </li>
                    <li>
                      {Language[languageStore].cikisTarih} :
                      {getUrunler.cikisTarih}
                    </li>
                    <li>
                      {Language[languageStore].basimEviTitle} :
                      {getUrunler.basimevi}
                    </li>
                  </ul>

                  <div className="border-bottom pt-20 mb-40" />
                  <div className="box-product-price">
                    <h3 className="color-brand-3 price-main d-inline-block mr-10">
                      {getUrunler.ucret}&nbsp;TL
                    </h3>
                  </div>

                  <div className="buy-product mt-20">
                    <p className="font-sm mb-20">
                      {Language[languageStore].uyelikUrunAdetTitle}
                    </p>
                    <div className="box-quantity">
                      <div className="input-quantity">
                        <input
                          className="font-xl color-brand-3"
                          type="text"
                          value={adetSayisi}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^\d*$/.test(value)) {
                              handleChangeAdet(e);
                            }
                          }}
                          name="adet-sayisi"
                          id={getUrunler.urunId}
                        />

                        <button
                          id={getUrunler.urunId}
                          name={`btn-dusur-${getUrunler.urunId}`}
                          onClick={(e) => AdetDusur(getUrunler)}
                          className="minus-cart"></button>
                        <button
                          id={getUrunler.urunId}
                          name={`btn-arttir-${getUrunler.urunId}`}
                          onClick={(e) => AdetArttir(getUrunler)}
                          className="plus-cart"></button>
                      </div>

                      <div className="button-buy">
                        <button
                          className="btn btn-cart"
                          name="sepete-ekle"
                          onClick={() => SepeteEkle(getUrunler)}>
                          {Language[languageStore].sepeteEkleBtnTitle}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default UrunDetay;
